import React from "react";
import LegalDoc from "../../components/LegalDoc";
import PublicNavbar from "../../components/PublicNavbar";
import UserNavbar from "../../components/UserNavbar";
import Footer from "../../components/Footer";
import { useAuth } from "../../utils/AuthContext";

const TermsOfService: React.FC = () => {
  const { isAuthenticated } = useAuth();

  return (
    <>
      {isAuthenticated ? <UserNavbar /> : <PublicNavbar />}
      <LegalDoc fileName="terms-of-service.txt" documentType="Terms of Service" />
      <Footer />
    </>
  );
};

export default TermsOfService;
